<template>
  <v-card id="table-firebase">
    <v-card-title id="card-title" ref="card-title">
      <v-checkbox
        :value="selectedAll"
        color="#6ec39b"
        :label="`เอกสารที่เลือก ${selectedList.length} ฉบับ `"
        @change="clickSelectedAll($event)"
      ></v-checkbox>

      <!-- <v-btn text :color="selectedList.filter((x) => !x.pdfUrl).length > 0 ? '#c9242b': '#6ec39b'" class="ml-10" @click.prevent="downloadPDF"
             :disabled="selectedList.length < 1 || downloadingPdf || selectedList.filter((x) => x.pdfUrl).length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.filter((x) => !x.xmlUrl).length > 0 && selectedList.filter((x) => x.xmlUrl).length >= 1 ? '/images/icons/icon_download_pdf_red.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>ดาวน์โหลด PDF {{ `(${selectedList.filter((x) => x.pdfUrl).length})` }}</span>
      </v-btn>-->

      <v-dialog v-model="exportDialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <button
            v-bind="attrs"
            v-on="on"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
            style="font-size: 0.875rem"
          >
            ส่งออกข้อมูล
          </button>
        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card>
              <v-card-title>
                <b>ส่งออกข้อมูล</b>
              </v-card-title>
              <v-card-text>
                <v-menu
                  v-model="menuDatePickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportStart"
                      label="วันที่เอกสารเริ่มต้น"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExportStart"
                    @input="menuDatePickerStart = false"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="menuDatePickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportEnd"
                      label="วันที่เอกสารสิ้นสุด"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExportEnd"
                    @input="menuDatePickerEnd = false"
                  ></v-date-picker>
                </v-menu>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancelExportDialog">
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  @click="exportDocs"
                >
                  <b>ส่งออกข้อมูล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

      <button
        v-if="$route.params.companyId === 'tdveuIDeccB2sdKGsh5q'"
        @click="exportDocsTest"
        class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-blue hover:tw-bg-light-blue hover:tw-text-white"
        style="font-size: 0.875rem"
      >
        ส่งออกข้อมูลtest
      </button>

      <v-dialog v-if="$route.params.companyId === 'tdveuIDeccB2sdKGsh5q'" v-model="importDialog" persistent max-width="650px">
        <template v-slot:activator="{ attrs }">
          <button
            v-bind="attrs"
            @click="onOpenImportDialog"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
            style="font-size: 0.875rem"
          >
            นำเข้าข้อมูล
          </button>
        </template>
        <template>
          <v-form ref="importForm" v-model="importFormValid">
            <v-card
              class="import-dialog-card"
              elevation="0"
              style="border-radius: 16px; overflow: hidden"
            >
              <v-card-title>
                <b>นำเข้าข้อมูล Excel</b>
              </v-card-title>
              <v-container v-if="alert.show && alert.showOnDialog == true">
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      v-model="alert.show"
                      :type="alert.type"
                      transition="scale-transition"
                      dismissible
                      >{{ alert.text }}</v-alert
                    >
                  </v-col>
                </v-row>
              </v-container>
              <v-card-text class="pa-8" style="background-color: #fafbfc">
                <!-- Template 1: Single File -->
                <div class="tmp-1">
                  <div class="mt-4">
                    <!-- Channel Type Selection -->
                    <v-select
                      v-model="selectedChannelType"
                      :items="channelTypeSelectItems"
                      item-text="text"
                      item-value="value"
                      label="ช่องทางการขาย"
                      outlined
                      color="#6ec39b"
                      prepend-inner-icon="mdi-store"
                    >
                      <template v-slot:selection="{ item }">
                        <v-chip small color="#6ec39b" text-color="white">
                          {{ item.text }}
                        </v-chip>
                      </template>
                    </v-select>

                    <div
                      @drop.prevent="onFileDrop"
                      @dragover.prevent="onDragOver"
                      @dragleave.prevent="onDragLeave"
                      :class="{ 'drag-active': isDragging }"
                      class="file-drop-zone"
                    >
                      <v-file-input
                        ref="importFileRef"
                        v-model="template1"
                        clearable
                        label="เลือกไฟล์ Excel"
                        hint="รองรับไฟล์ .xlsx และ .xls เท่านั้น"
                        persistent-hint
                        color="#6ec39b"
                        outlined
                        prepend-icon=""
                        prepend-inner-icon="mdi-file-excel-outline"
                        placeholder="คลิกเพื่อเลือกไฟล์ หรือลากไฟล์มาวางที่นี่"
                        @change="handleImportFile"
                        accept=".xlsx,.xls"
                        show-size
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip small color="#6ec39b" text-color="white">
                            <v-icon x-small left>mdi-check</v-icon>
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                    </div>
                  </div>
                </div>

                <!-- Upload Progress -->
                <div v-if="uploadingExcel" class="px-8 pb-4">
                  <v-progress-linear
                    :value="displayProgress"
                    color="#6ec39b"
                    height="25"
                    rounded
                    class="smooth-progress"
                  >
                    <template v-slot:default="{ value }">
                      <strong class="white--text">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                  <div class="text-center mt-2 text-body-2" style="color: #2c3e50">
                    {{ uploadProgressMessage }}
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  v-if="enableCsvUploadHistory"
                  text
                  color="info"
                  @click="goToUploadHistory"
                  :disabled="uploadingExcel"
                >
                  <v-icon small class="mr-2">mdi-history</v-icon>
                  ดูประวัติ
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="cancelImportDialog"
                  :disabled="uploadingExcel"
                >
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  @click="importDocs"
                  :loading="uploadingExcel"
                  :disabled="uploadingExcel"
                >
                  <v-icon v-if="!uploadingExcel" class="mr-2"
                    >mdi-cloud-upload</v-icon
                  >
                  <b v-if="!uploadingExcel">นำเข้าข้อมูล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

      <v-spacer></v-spacer>

      <!-- <popover-menu
        style="padding-right: 20px"
        buttonText="กรอง"
        titleText="แสดงเอกสารเฉพาะ"
        :option-list="optionFilterList"
        :value-list="valueFilterList"
        @change-value-filter-list="onChangeValueFilterList"
        buttonIcon="/images/icons/icon_filter.svg"
        :defaultListItem="defaultValueFilterList"
        :disablePopOver="disablePopOver"
      ></popover-menu> -->

      <popover-menu
        style="padding-right: 20px"
        buttonText="ซ่อน"
        titleText="เลือกคอลัมน์ที่ต้องการซ่อน"
        :option-list="optionHideList"
        :value-list="valueHideList"
        @change-value-filter-list="onChangeValueDropdownHideColumn"
        buttonIcon="/images/icons/icon_hidden.svg"
        :defaultListItem="defaultValueHideList"
      ></popover-menu>

      <popover-menu-radio
        style="padding-right: 20px"
        buttonText="ตั้งค่าการค้นหา"
        titleText="เลือกคอลัมน์ที่ต้องการค้นหา"
        :option-list="searchOptionList"
        @change-value-option="onChangeValueSearchOption"
        buttonIcon="/images/icons/icon_search_setting.svg"
        :defaultValue="defaultSearchOptionValue"
      ></popover-menu-radio>

      <!-- fromDateVal:: {{ fromDateVal }}
          toDateVal:: {{ toDateVal }} -->

      <div
        v-if="
          defaultSearchOptionValue != 'timeOrderCreated' &&
          defaultSearchOptionValue !== '@ChannelType'
        "
        class="search-box"
      >
        <v-text-field
          :value="keyword"
          :label="`ค้นหา จาก ${
            searchOptionList?.find(
              (item) => item.key === defaultSearchOptionValue
            )?.label
          }`"
          append-icon="mdi-magnify"
          :placeholder="`ค้นหา จาก ${
            searchOptionList?.find(
              (item) => item.key === defaultSearchOptionValue
            )?.label
          }`"
          outlined
          @input="debounceInput"
        ></v-text-field>
      </div>

      <div
        v-if="defaultSearchOptionValue == 'timeOrderCreated'"
        class="tw-flex tw-gap-4"
      >
        <v-menu
          v-model="fromDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="292px"
          min-width="292px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="จากวันที่เอกสาร"
              append-icon="mdi-calendar-month-outline"
              readonly
              :value="fromDateDisp"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            color="primary"
            locale="en-in"
            v-model="fromDateVal"
            no-title
            @input="fromDateMenu = false"
            :min="minDate"
          ></v-date-picker>
        </v-menu>

        <v-menu
          v-model="toDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="292px"
          min-width="292px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="ถึงวันที่"
              append-icon="mdi-calendar-month-outline"
              readonly
              :value="toDateDisp"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            color="primary"
            locale="en-in"
            v-model="toDateVal"
            no-title
            @input="toDateMenu = false"
            :min="minToDate"
          ></v-date-picker>
        </v-menu>

        <v-btn
          text
          color="#f05d5d"
          type="button"
          outlined
          class="btn-submit tw-self-center"
          @click="resetDateSearch"
        >
          <v-icon small>mdi-restart</v-icon>
          <b>รีเซ็ตค่า</b>
        </v-btn>
      </div>

      <div
        v-if="defaultSearchOptionValue == '@ChannelType'"
        class="tw-flex tw-gap-4"
      >
        <v-select
          label="ค้นหา จาก ช่องทาางการขาย"
          :items="channelTypeItems"
          item-text="text"
          item-value="value"
          @change="changeKeyword"
        ></v-select>
      </div>
    </v-card-title>

    <v-container v-if="alert.show">
      <v-row>
        <v-col cols="12">
          <v-alert
            v-model="alert.show"
            :type="alert.type"
            transition="scale-transition"
            dismissible
            >{{ alert.text }}</v-alert
          >
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="pdfDialog">
      <div>
        <iframe class="iframe" :src="pdfSrc"></iframe>
      </div>
    </v-dialog>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr id="header-table">
            <th />
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('timeOrderCreated')"
              v-if="[
                showColumn('timeOrderCreated'),
                defaultOrder('timeOrderCreated'),
              ]"
            >
              วันที่เอกสาร
              <img
                v-if="orderBySelect['key'] === 'timeOrderCreated'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'timeOrderCreated'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('@ChannelType')"
            >
              ช่องทางการขาย
              <img
                v-if="orderBySelect['key'] === '@ChannelType'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== '@ChannelType'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('orderID')"
              v-if="showColumn('orderID')"
            >
              เลขที่ใบสั่งขาย
              <img
                v-if="orderBySelect['key'] === 'orderID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'orderID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('buyerName')"
              v-if="showColumn('buyerName')"
            >
              ชื่อผู้ซื้อ / ชื่อบริษัท
              <img
                v-if="orderBySelect['key'] === 'buyerName'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'buyerName'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('orderAmountTotal')"
              v-if="showColumn('orderAmountTotal')"
            >
              ยอดรวม
              <img
                v-if="orderBySelect['key'] === 'orderAmountTotal'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'orderAmountTotal'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-center order-by-row"
              @click="changeOrderBy('@TimeDBUpdated')"
              v-if="showColumn('@TimeDBUpdated')"
            >
              ซิงค์ข้อมูล
              <img
                v-if="orderBySelect['key'] === '@TimeDBUpdated'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== '@TimeDBUpdated'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left"
              style="min-width: 80px"
              @click="changeOrderBy('@DBSaleDocID')"
              v-if="showColumn('@DBSaleDocID')"
            >
              เลขที่ใบสั่งขายจากระบบบัญชี
              <img
                v-if="orderBySelect['key'] === '@DBSaleDocID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== '@DBSaleDocID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in docs" :key="doc.id" class="tr-data">
            <td>
              <!-- ซ่อน checkbox ถ้า sync สำเร็จแล้ว -->
              <v-checkbox
                v-if="!isSyncedToSAP(doc)"
                color="#6ec39b"
                :input-value="getCheckedSelect(doc.id)"
                class="remove-checkbox-padding"
                @change="clickSelected(doc)"
              ></v-checkbox>
              <!-- แสดง icon ถ้า sync แล้ว -->
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="#9e9e9e"
                    v-bind="attrs"
                    v-on="on"
                  >mdi-lock</v-icon>
                </template>
                <span>ส่งออกแล้ว: {{ doc['@DBSaleDocID'] }}</span>
              </v-tooltip>
            </td>
            <td
              v-if="showColumn('timeOrderCreated')"
              :disabled="downloadPdfLoading"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <div class="check-box-flex">
                <img
                  v-if="doc['@DownloadedXml']"
                  src="/images/icons/icon_downloaded.svg"
                  alt="downloaded"
                  class="icon-downloaded"
                />
                <span
                  >{{ getDateWithFormat(doc["timeOrderCreated"]) }}
                  <!-- -- {{ formatDateDur(doc["timeOrderCreated"]) }} -->
                </span>
              </div>
            </td>
            <td
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ renderChannelType(doc["@ChannelType"]) }}
            </td>
            <td
              v-if="showColumn('orderID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["orderID"] }}
            </td>
            <td
              v-if="showColumn('buyerName')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["buyerName"] }}
            </td>
            <td
              class="text-right"
              v-if="showColumn('orderAmountTotal')"
              v-html="getFormatAmount(doc['orderAmountTotal'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td class="text-center" v-if="showColumn('@TimeDBUpdated')">
              <!-- SAP Sync Status -->
              <div v-if="doc['@SyncStatus'] === 'success'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dark color="#6ec39b" v-bind="attrs" v-on="on">
                      mdi-check-circle-outline
                    </v-icon>
                  </template>
                  <span>ซิงค์สำเร็จ: {{ doc['@DBSaleDocID'] || 'ไม่มีเลขที่' }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="doc['@SyncStatus'] === 'error'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      color="error"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="clickSyncErrorButton(doc)"
                    >
                      ผิดพลาด
                    </v-btn>
                  </template>
                  <span>{{ doc['@SyncError'] || 'เกิดข้อผิดพลาดในการซิงค์' }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="doc['@DBSaleDocID']">
                <!-- มี SAP Doc ID แต่ไม่มี SyncStatus (อาจเป็นข้อมูลเก่า) -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dark color="#6ec39b" v-bind="attrs" v-on="on">
                      mdi-check-circle-outline
                    </v-icon>
                  </template>
                  <span>เลขที่ใบสั่งขาย: {{ doc['@DBSaleDocID'] }}</span>
                </v-tooltip>
              </div>
              <!-- Legacy error handling -->
              <span
                v-else-if="
                  doc['@IsNeedUpdate'] != true &&
                  (!doc['@Errors'] || doc['@Errors'].length == 0)
                "
              >
                <v-icon dark color="#6ec39b">mdi-check-circle-outline</v-icon>
              </span>
              <span v-else-if="doc['@Errors'] && doc['@Errors'].length > 0">
                <v-btn
                  x-small
                  color="error"
                  dark
                  @click="clickErrorButton(doc)"
                >
                  ผิดพลาด
                </v-btn>
              </span>
              <span v-else>
                <v-icon dark color="#9e9e9e">mdi-minus-circle-outline</v-icon>
              </span>
            </td>
            <td
              class="text-left"
              v-if="showColumn('@DBSaleDocID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <span v-if="doc['@DBSaleDocID']">{{ doc['@DBSaleDocID'] }}</span>
              <span v-else class="tw-text-gray-400">-</span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div
      v-if="docs.length == 0 && !loading"
      class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
    >
      <h2>ไม่พบเอกสารที่ต้องการ</h2>
    </div>
    <v-dialog v-model="dialogError" width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">ข้อผิดพลาด</span>
        </v-card-title>
        <v-card-text v-if="dialogDoc">
          {{ dialogDoc["@Errors"] }}
        </v-card-text>
        <v-card-actions>
          <v-checkbox
            v-model="checkBoxErrorFix"
            label="แก้ไขปัญหาเรียบร้อยแล้ว"
            color="primary"
            value="true"
            hide-details
          ></v-checkbox>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="clickErrorOK(dialogDoc)" dark>
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSyncError" width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">ข้อผิดพลาดในการซิงค์ข้อมูล SAP</span>
        </v-card-title>
        <v-card-text v-if="dialogSyncErrorDoc">
          <div class="tw-mb-4">
            <strong>เลขที่ใบสั่งขาย:</strong> {{ dialogSyncErrorDoc["orderID"] }}
          </div>
          <div class="tw-mb-4">
            <strong>ข้อความผิดพลาด:</strong>
            <div class="tw-mt-2 tw-p-2 tw-bg-red-50 tw-rounded">
              {{ dialogSyncErrorDoc["@SyncError"] || "ไม่ทราบสาเหตุ" }}
            </div>
          </div>
          <div v-if="dialogSyncErrorDoc['@DBSaleDocID']" class="tw-mb-2">
            <strong>เลขที่ใบสั่งขายจากระบบบัญชี:</strong> {{ dialogSyncErrorDoc["@DBSaleDocID"] }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogSyncError = false" dark>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-progress-linear
      indeterminate
      color="green"
      :active="loading || downloadPdfLoading"
    ></v-progress-linear>
    <div class="float-left mt-2" v-if="!showPaginationTemplate">
      <div class="tw-relative">
        <v-btn
          class="ma-2 page-arrow-size"
          outlined
          color="#707070"
          @click="onClickPreviousPagination"
          :disabled="!canPrevPage() || $apollo.loading"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn class="page-count-size" outlined color="#c9242b">{{
          page
        }}</v-btn>
        <v-btn
          class="ma-2 page-arrow-size"
          outlined
          color="#707070"
          @click="onClickNextPagination"
          :disabled="!canNextPage() || $apollo.loading"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <button
          class="hover:tw-bg-light-gray tw-px-4 tw-py-2 tw-rounded-md"
          v-on:click="showPagination = !showPagination"
        >
          <span>{{ getPageDesc() }}</span>
        </button>
        <div
          class="tw-absolute tw-right-0 tw-bg-white tw-w-52 tw-shadow-lg tw-rounded-md tw-p-2"
          v-if="showPagination"
        >
          <v-radio-group
            :value="itemsPerPage"
            column
            @change="onChangePagination"
          >
            <v-radio
              label="แสดงหน้าละ 10 รายการ"
              color="#6ec39b"
              value="10"
            ></v-radio>
            <v-radio
              label="แสดงหน้าละ 30 รายการ"
              color="#6ec39b"
              value="30"
            ></v-radio>
            <v-radio
              label="แสดงหน้าละ 50 รายการ"
              color="#6ec39b"
              value="50"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
    </div>
    <SaleordersReport
      :openDialog="openSaleordersDialog"
      :doc="saleordersDialogDoc"
      v-on:close-dialog="closeDialog"
    />
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import saleorders from "@/store/collection/saleorders";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
// import zipFiles from "@/libs/zipFiles";
import isMobile from "../../../libs/detectMobile";
import moment from "moment-timezone";
import "moment/locale/th";
import PopoverMenu from "./popoverMenu";
import PopoverMenuRadio from "./popoverMenuRadio";
import formatTwoDecimal from "@/libs/formatTwoDecimal";
import getErrorMessage from "@/libs/getErrorMessage";
// import { docsQuery } from "../../../store/collection/saleorders"
import companyStatus from "@/libs/companyStatus";
import SaleordersReport from "./saleorders.report";
import libCSV from "@/libs/libCSV";
import { readExcelFile, validateExcelFile } from "@/libs/excelReader";

const axios = require("axios");
const _ = require("lodash");

moment.locale("th");

export default {
  components: {
    PopoverMenu,
    PopoverMenuRadio,
    SaleordersReport,
  },
  data() {
    return {
      channelTypeItems: [
        { value: "1", text: "Shopee" },
        { value: "2", text: "Lazada" },
        { value: "3", text: "TikTok" },
      ],
      fromDateMenu: false,
      fromDateVal: null,
      minDate: "1990-01-05",
      maxDate: new Date(),
      toDateMenu: false,
      toDateVal: null,
      minDateToDate: this.fromDateVal,
      dialogError: false,
      dialogDoc: null,
      checkBoxErrorFix: false,
      dialogSyncError: false,
      dialogSyncErrorDoc: null,
      openSaleordersDialog: false,
      saleordersDialogDoc: {},
      selectedAll: false,
      emailDialog: false,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      emailValid: false,
      sendEmailLoading: false,
      sendEmailSuccessCount: 0,
      alert: {
        text: "",
        type: "success",
        show: false,
      },
      pdfDialog: false,
      pdfSrc: "",
      downloadPdfLoading: false,
      optionFilterList: [
        { label: "ดาวน์โหลดแล้ว", key: "@DownloadedXml" },
        { label: "ยังไม่ได้ดาวน์โหลด", key: "not-download" },
      ],
      defaultValueFilterList: ["@DownloadedXml", "not-download"],
      optionHideList: [
        { label: "แสดงทั้งหมด", key: "all" },
        { label: "วันที่เอกสาร", key: "timeOrderCreated" },
        { label: "ช่องทางการขาย", key: "@ChannelType" },
        { label: "เลขที่ใบสั่งขาย", key: "orderID" },
        { label: "ชื่อผู้ซื้อ / ชื่อบริษัท", key: "buyerName" },
        { label: "ยอดรวม", key: "orderAmountTotal" },
        { label: "ซิงค์ข้อมูล", key: "@TimeDBUpdated" },
        { label: "เลขที่ใบสั่งขายจากระบบบัญชี", key: "@DBSaleDocID" },
      ],
      valueHideList: [
        "all",
        "timeOrderCreated",
        "@ChannelType",
        "orderID",
        "buyerName",
        "orderAmountTotal",
        "@TimeDBUpdated",
        "@DBSaleDocID",
      ],
      defaultValueHideList: [
        "all",
        "timeOrderCreated",
        "@ChannelType",
        "orderID",
        "buyerName",
        "orderAmountTotal",
        "@TimeDBUpdated",
        "@DBSaleDocID",
      ],
      disablePopOver: false,
      defaultSearchOptionValue: "orderID",
      searchOptionList: [
        { label: "วันที่เอกสาร", key: "timeOrderCreated" },
        { label: "ช่องทางการขาย", key: "@ChannelType" },
        { label: "เลขที่ใบสั่งขาย", key: "orderID" },
        { label: "ชื่อผู้ซื้อ/ชื่อบริษัท", key: "buyerName" },
        { label: "ยอดรวม", key: "orderAmountTotal" },
        // { label: "ซิงค์ข้อมูล", key: "@TimeDBUpdated" },
        { label: "เลขที่ใบสั่งขายจากระบบบัญชี", key: "@DBSaleDocID" },
      ],
      mouse: false,
      dragging: false,
      height: 0,
      resize: false,
      //filter
      filter: {
        issueDateTimeRange: [],
        objectId: "",
        scttAhtaBtpId: "",
        buyerBranchId: "",

        typeLineTotal: "",
        lineTotal: [],

        typeTaxTotal: "",
        taxTotal: [],

        typeGrandTotal: "",
        grandTotal: [],

        timeSignedXmlRange: [],
        docType: "",
        status: {
          downloadedXml: null,
          signSuccess: null,
          missingInfo: null,
          mailSent: null,
          suspendedAccount: null,
          buyerEmail_Isnull: null,
        },
      },
      channelType: {
        1: "Shopee",
        2: "Lazada",
        3: "TikTok",
      },
      // pagination
      pageInfo: null,
      totalCount: 0,
      edgeCount: 0,
      page: 1,
      itemsPerPage:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"), // hardcode for auto case
      first:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"),
      after: null,
      last: null,
      before: null,
      hasNextPage: null,
      hasPreviousPage: null,
      startCursor: null,
      endCursor: null,
      showPagination: false,

      // gql
      skipQuery: true,

      // email
      emailList: {},
      emailInput: "",
      awaitingDrag: false,
      timer: false,
      sentEmailHover: false,

      // export
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      exportDialog: false,
      dateExportStart: "",
      dateExportEnd: "",

      // import
      importDialog: false,
      importFormValid: false,
      uploadingExcel: false,
      uploadProgress: 0,
      displayProgress: 0,
      progressInterval: null,
      uploadProgressMessage: "",
      template1: null,
      selectedChannelType: null,
      channelTypeSelectItems: [
        { value: "1", text: "Shopee" },
        { value: "2", text: "Lazada" },
        { value: "3", text: "TikTok" },
      ],
      enableCsvUploadHistory: false,
      isDragging: false,
    };
  },
  created() {
    this.onResetPage();
    this.query();
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.handleResize, 100);
    });
    this.handleResize();
  },
  beforeDestroy() {
    this.$store.dispatch("saleorders/getDocListUnsubscribe");
    // Clean up progress animation interval
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapState({
      docs: (state) => state.saleorders.list,
      loading: (state) => state.saleorders.loading,
      // page: state => state.docs.page,
      keyword: (state) => state.saleorders.keyword,
      downloaded: (state) => state.docsDownloaded.downloaded,
      downloadingXml: (state) => state.docsDownloaded.downloadingXml,
      downloadingPdf: (state) => state.docsDownloaded.downloadingPdf,
      selectedBranch: (state) => state.companies.selectedBranch,
      orderBySelect: (state) => state.saleorders.orderBySelect,
      valueFilterList: (state) => state.saleorders.valueFilterList,
      selectedList: (state) => state.saleorders.selectedList,
      showPaginationTemplate: (state) =>
        state.saleorders.showPaginationTemplate,
      companyStatus: (state) => state.statusesByCompany.companyStatus,
      globalLoading: (state) => state.loading.globalLoading,
    }),
    fromDateDisp() {
      return this.fromDateVal;
      // format/do something with date
    },
    toDateDisp() {
      return this.toDateVal;
      // format/do something with date
    },
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.fromDateDisp);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().substr(0, 10); // Format as "YYYY-MM-DD"
    },
  },
  watch: {
    defaultSearchOptionValue: {
      handler: function () {
        this.$store.dispatch("saleorders/updateKeyword", "");
        this.clearValue();
        this.clearSelectList();
        this.query();
      },
    },
    fromDateVal: {
      handler: function () {
        this.$store.dispatch("saleorders/setFromDate", this.fromDateVal);
        if (this.fromDateVal !== "") {
          this.query();
        }
      },
    },
    toDateVal: {
      handler: function () {
        this.$store.dispatch("saleorders/setToDate", this.toDateVal);
        if (this.toDateVal !== "") {
          this.query();
        }
      },
    },
    dialogError(visible) {
      if (visible) {
        this.checkBoxErrorFix = false;
      }
    },
    selectedBranch: {
      handler: function () {
        this.query();
      },
    },
    $route() {
      this.clearValue();
      this.query();
    },
    valueFilterList: {
      handler: function () {
        this.query();
      },
    },
    selectedList: {
      handler: function () {
        this.checkSelectedAll();
      },
    },
    docs: {
      handler: function () {
        this.checkSelectedAll();
      },
    },
    height: {
      handler: function () {
        this.matchHeight();
      },
    },
  },
  methods: {
    animateProgress(targetValue) {
      return new Promise((resolve) => {
        // Clear existing interval
        if (this.progressInterval) {
          clearInterval(this.progressInterval);
        }

        const startValue = this.displayProgress;
        const diff = targetValue - startValue;

        // ถ้าไม่มีการเปลี่ยนแปลง resolve ทันที
        if (diff === 0) {
          resolve();
          return;
        }

        const duration = 400; // 400ms animation
        const steps = 25;
        const stepDuration = duration / steps;
        let currentStep = 0;

        this.progressInterval = setInterval(() => {
          currentStep++;
          if (currentStep >= steps) {
            this.displayProgress = targetValue;
            clearInterval(this.progressInterval);
            this.progressInterval = null;
            resolve();
          } else {
            // Ease-out cubic for smooth animation
            const progress = currentStep / steps;
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            this.displayProgress = startValue + (diff * easeProgress);
          }
        }, stepDuration);
      });
    },
    // Simulate progress while waiting for server response
    startIndeterminateProgress(fromValue, toValue) {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
      }

      const range = toValue - fromValue;
      let elapsed = 0;
      const intervalMs = 100;

      this.progressInterval = setInterval(() => {
        elapsed += intervalMs;
        // Asymptotic approach - gets slower as it approaches target
        const progress = 1 - Math.exp(-elapsed / 8000);
        this.displayProgress = fromValue + (range * progress * 0.95); // Never quite reach toValue
        this.uploadProgress = this.displayProgress;
      }, intervalMs);
    },
    stopIndeterminateProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
    },
    clickErrorButton(doc) {
      console.log("doc", doc);
      this.dialogDoc = doc;
      this.dialogError = true;
    },
    clickSyncErrorButton(doc) {
      console.log("sync error doc", doc);
      this.dialogSyncErrorDoc = doc;
      this.dialogSyncError = true;
    },
    async clickErrorOK(doc) {
      console.log("###### clickErrorOK", doc);
      if (this.checkBoxErrorFix) {
        let data = {
          "@IsNeedUpdate": true,
          "@Errors": [],
        };
        const companyId = this.$route.params.companyId;
        const ref = fc.db.doc(
          `/Companies/${companyId}/SaleOrders/${doc["id"]}`
        );
        await ref.set(data, { merge: true });
      }
      this.dialogError = false;
    },
    closeDialog() {
      this.openSaleordersDialog = false;
    },
    renderChannelType(type) {
      if (!type) return "";
      return this.channelType[type];
    },
    startDrag() {
      this.timer = false;
      this.dragging = false;
      this.mouse = true;
    },
    stopDrag(doc) {
      if (!this.dragging && this.mouse) {
        // this.onClickDocId(doc['@SignedPdfUrl'])
        // this.onClickDocId(doc)
        this.saleordersDialogDoc = doc;
        this.openSaleordersDialog = true;
      }
      this.dragging = false;
      this.mouse = false;
    },
    doDrag() {
      if (this.mouse && !this.awaitingDrag) {
        this.timer = setTimeout(() => {
          this.dragging = true;
          this.awaitingDrag = false;
        }, 200);
        this.awaitingDrag = true;
      }
    },
    matchHeight() {
      if (localStorage.getItem("pageLimit") !== "auto") return;
      let cardTitle = document.getElementById("card-title").clientHeight || 0;
      let headerTable =
        document.getElementById("header-table").clientHeight || 0;
      let rowDetailRow = Math.floor(
        (this.height - (150 + cardTitle + headerTable)) / 67
      );
      let pageLimit = 10;
      pageLimit =
        rowDetailRow > 1
          ? rowDetailRow - 1
          : rowDetailRow >= 0
          ? rowDetailRow
          : 1;

      localStorage.setItem("pageLimitAuto", pageLimit.toString());
      this.$store.dispatch("user/setPageLimitAutoChange");
      this.clearValue();
      this.query();
    },
    handleResize() {
      this.height = window.innerHeight;
    },
    getTaxId: function (taxID) {
      let taxIDShow = "-";
      if (taxID && taxID.length > 13) {
        taxIDShow = taxID.substring(0, 13);
      } else if (taxID && taxID.length <= 13) {
        taxIDShow = taxID;
      }
      return taxIDShow;
    },
    getCheckedSelect: function (docID) {
      return this.selectedList.some((x) => x["docID"] === docID);
    },
    isSyncedToSAP: function (doc) {
      // ตรวจสอบว่า sync สำเร็จแล้วหรือยัง
      // ถ้า SyncStatus = 'success' หรือมี @DBSaleDocID ถือว่า sync แล้ว
      return doc['@SyncStatus'] === 'success' || !!doc['@DBSaleDocID'];
    },
    getFormatAmount(amount) {
      return formatTwoDecimal(amount);
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate())
          .add(543, "years")
          .format("Do MMM YY, LTS");
      }
      return "-";
    },
    query: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("saleorders/getList", {
          id: companyId,
          selectedBranch: this.selectedBranch,
        });
      }
    },
    getEmailList: function () {
      for (let e of this.selectedList) {
        if (e.docID) {
          if (!this.emailList[e.docID]) {
            this.emailList[e.docID] = [];
          }
          if (e.buyerEmail) {
            this.emailList[e.docID] = Vue.observable(
              e.buyerEmail.replaceAll(";", ",").split(",")
            );
          } else {
            this.emailList[e.docID] = Vue.observable([]);
          }
        }
      }
    },
    clearEmailList: function () {
      this.emailDialog = false;
      this.emailList = {};
    },
    exportDocs() {
      const companyID = this.$route.params.companyId;
      const timeStart = moment(this.dateExportStart + "T00:00:00.000+07:00");
      const timeEnd = moment(this.dateExportEnd + "T00:00:00.000+07:00").add(
        1,
        "days"
      );

      let q = fc.db.collection(`Companies/${companyID}/SaleOrders`);
      q = q.where(
        new firebase.firestore.FieldPath("timeOrderCreated"),
        ">=",
        timeStart.toDate()
      );
      q = q.where(
        new firebase.firestore.FieldPath("timeOrderCreated"),
        "<",
        timeEnd.toDate()
      );
      q = q.orderBy(new firebase.firestore.FieldPath("timeOrderCreated"));
      q.get().then((querySnapshot) => {
        const rows = [
          [
            "วันที่เอกสาร", // timeOrderCreated
            "เลขที่ใบสั่งขาย", // orderID
            "ชื่อผู้ซื้อ/ชื่อบริษัท", // buyerName
            // "มูลค่าสินค้า/บริการ",
            // "มูลค่าที่นำมาคิดภาษี",
            // "ภาษีมูลค่าเพิ่ม",
            "ยอดรวม", // orderAmountTotal
            "เลขที่ใบสั่งขายจากระบบบัญชี", // @DBSaleDocID
            "ช่องทางการขาย", // @ChannelType this.channelType[type]
          ],
        ];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          console.log(data);
          rows.push([
            [
              moment(data["timeOrderCreated"].toDate())
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD"),
              data["orderID"],
              data["buyerName"],
              // "มูลค่าสินค้า/บริการ",
              // "มูลค่าที่นำมาคิดภาษี",
              // "ภาษีมูลค่าเพิ่ม",
              libCSV.stangToTHB(data["orderAmountTotal"]),
              data["@DBSaleDocID"],
              this.channelType[data["@ChannelType"]],
            ],
          ]);
        });
        libCSV.exportCSV(
          `SaleOrders_${this.dateExportStart}_${this.dateExportEnd}.csv`,
          rows
        );
        this.exportDialog = false;
      });
    },
    cancelExportDialog() {
      this.exportDialog = false;
    },
    async exportDocsTest() {
      try {
        // Step 1: Validate - ต้องเลือกเอกสารอย่างน้อย 1 ฉบับ
        if (!this.selectedList || this.selectedList.length === 0) {
          this.alert = {
            text: "กรุณาเลือกเอกสารที่ต้องการส่งออก",
            type: "error",
            show: true,
            showOnDialog: false,
          };
          return;
        }

        const companyId = this.$route.params.companyId;
        if (!companyId) {
          this.alert = {
            text: "ไม่พบ Company ID",
            type: "error",
            show: true,
            showOnDialog: false,
          };
          return;
        }

        // Step 2: ดึง databaseId จาก Databases collection
        const databasesRef = await fc.db
          .collection(`Companies/${companyId}/Databases`)
          .get();

        if (databasesRef.empty) {
          this.alert = {
            text: "ไม่พบการตั้งค่า Database กรุณาติดต่อผู้ดูแลระบบ",
            type: "error",
            show: true,
            showOnDialog: false,
          };
          return;
        }

        const databaseId = databasesRef.docs[0].id; // ใช้ document แรกที่เจอ

        // Step 3: รวบรวมข้อมูลจาก selectedList
        const documents = this.selectedList.map((selected) => {
          // หา doc ที่ตรงกับ docID จาก docs list
          const doc = this.docs.find((d) => d.id === selected.docID);
          return {
            docID: selected.docID,
            orderID: doc?.orderID || "",
            buyerName: doc?.buyerName || "",
            orderAmountTotal: doc?.orderAmountTotal || 0,
            timeOrderCreated: doc?.timeOrderCreated || null,
            channelType: doc?.["@ChannelType"] || null,
            dbSaleDocID: doc?.["@DBSaleDocID"] || "",
            // เพิ่มข้อมูลอื่นๆ ที่ต้องการส่งไป SAP
          };
        });

        // Step 4: เรียก HTTP Endpoint (รัน local - สามารถ resolve hostname ได้)
        this.$store.dispatch("setGlobalLoading", true);
        
        // Get auth token
        const token = await firebase.auth().currentUser.getIdToken();
        const headers = {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        };

        const apiUrl = fc.cloudFunctionUrl + "apiExportToSAPLocal";
        console.log("[exportDocsTest] Calling API:", apiUrl);
        console.log("[exportDocsTest] Request data:", {
          companyId: companyId,
          databaseId: databaseId,
          documentsCount: documents.length,
        });

        const response = await axios.post(
          apiUrl,
          {
            companyId: companyId,
            databaseId: databaseId,
            documents: documents.map(doc => ({ docID: doc.docID })),
          },
          { 
            headers,
            timeout: 600000, // 10 minutes timeout
          }
        );

        const result = response.data;

        // Step 5: แสดงผลลัพธ์
        if (result.success) {
          this.alert = {
            text: result.message || `ส่งออกข้อมูลสำเร็จ ${result.count || result.results?.length || 0} รายการ`,
            type: "success",
            show: true,
            showOnDialog: false,
          };
          
          // Refresh ข้อมูลในตาราง
          this.query();
        } else {
          const errorMessage = result.message || result.error || "เกิดข้อผิดพลาดในการส่งออก";
          this.alert = {
            text: errorMessage,
            type: "error",
            show: true,
            showOnDialog: false,
          };
        }
      } catch (error) {
        console.error("Error exporting to SAP:", error);
        console.error("Error details:", {
          message: error.message,
          code: error.code,
          response: error.response,
          request: error.request,
          config: error.config,
        });
        
        let errorMessage = "ไม่ทราบสาเหตุ";
        
        if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
          errorMessage = "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบ:\n" +
            "1) Cloud Function apiExportToSAPLocal ได้ถูก deploy แล้วหรือยัง\n" +
            "2) URL: " + (fc.cloudFunctionUrl + "apiExportToSAPLocal") + "\n" +
            "3) การเชื่อมต่ออินเทอร์เน็ต";
        } else if (error.response) {
          // Server responded with error status
          errorMessage = error.response.data?.error || error.response.data?.message || `HTTP ${error.response.status}: ${error.response.statusText}`;
        } else if (error.request) {
          // Request was made but no response received
          errorMessage = "ไม่ได้รับคำตอบจากเซิร์ฟเวอร์ กรุณาตรวจสอบการเชื่อมต่อ";
        } else {
          errorMessage = error.message || "ไม่ทราบสาเหตุ";
        }
        
        this.alert = {
          text: "เกิดข้อผิดพลาด: " + errorMessage,
          type: "error",
          show: true,
          showOnDialog: false,
        };
      } finally {
        this.$store.dispatch("setGlobalLoading", false);
      }
    },
    clickSelectedAll: function (checked) {
      let selectedList = _.cloneDeep(this.selectedList);
      if (checked) {
        saleorders.state.list.forEach((doc) => {
          // ไม่เลือกรายการที่ sync แล้ว
          if (!this.isSyncedToSAP(doc) && !selectedList.some((x) => x["docID"] === doc.id)) {
            selectedList.push({
              docID: doc.id,
              pdfUrl: doc["@SignedPdfUrl"],
              xmlUrl: doc["@SignedXmlUrl"],
              buyerEmail: doc["@BuyerEmail"],
            });
          }
        });
      } else {
        saleorders.state.list.forEach((doc) => {
          let index = selectedList.findIndex((x) => x["docID"] === doc.id);
          if (index !== -1) {
            selectedList.splice(index, 1);
          }
        });
      }
      this.$store.dispatch("saleorders/setSelectedList", {
        selectedList: selectedList,
      });
    },
    clickSelected: function (doc) {
      let valueList = _.cloneDeep(this.selectedList);
      if (this.getCheckedSelect(doc.id)) {
        let index = valueList.findIndex((x) => x["docID"] === doc.id);
        valueList.splice(index, 1);
      } else {
        valueList.push({
          docID: doc.id,
          pdfUrl: doc["@SignedPdfUrl"],
          xmlUrl: doc["@SignedXmlUrl"],
          buyerEmail: doc["@BuyerEmail"],
        });
      }

      this.$store.dispatch("saleorders/setSelectedList", {
        selectedList: valueList,
      });
    },
    checkSelectedAll: function () {
      let selectedAll = false;
      let checkCount = 0;
      this.selectedList.forEach((select) => {
        if (saleorders.state.list.some((doc) => doc.id === select.docID)) {
          checkCount++;
        }
      });
      if (
        checkCount === saleorders.state.list.length &&
        saleorders.state.list.length > 0
      ) {
        selectedAll = true;
      }
      this.selectedAll = selectedAll;
    },
    debounceInput: _.debounce(function (keyword) {
      this.changeKeyword(keyword);
    }, 1000),
    changeKeyword: function (keyword) {
      this.clearValue();
      let companyId = this.$route.params.companyId;

      console.log("this.selectedChannel:: ", this.selectedChannel);

      if (this.selectedChannel) {
        keyword = this.selectedChannel.text;
      }

      if (companyId) {
        this.$store.dispatch("saleorders/updateKeyword", {
          id: companyId,
          keyword: keyword,
        });

        this.query();
        let resizeId;
        window.addEventListener("resize", () => {
          clearTimeout(resizeId);
          resizeId = setTimeout(this.handleResize, 100);
        });
        this.handleResize();
      }
    },
    validateEmail: function () {
      if (this.$refs.form.validate()) {
        this.emailDialog = false;
        this.sendEmail();
      }
    },
    sendEmail: async function () {
      this.sendEmailLoading = true;

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      // let allEmailFill = (this.emailList.join(',').replaceAll(';',',')).split(",")
      // let allEmailSelected = (this.selectedList.map(select => {
      //   return select['buyerEmail'].replaceAll(';',',')
      // }))
      // allEmailSelected = (allEmailSelected.join(',')).split(',')
      // let emailWouldSend = []
      // for(let e of allEmailFill) {
      //   if(!allEmailSelected.includes(e)){
      //     emailWouldSend.push(e)
      //   }
      // }
      // const promises = this.selectedList.map(async (select) => {
      //   let allEmailSend = select['buyerEmail'].replaceAll(';',',')
      //   if(emailWouldSend.length>0){
      //     if(allEmailSend) {
      //       allEmailSend += ',' + emailWouldSend.join(',')
      //     }else{
      //       allEmailSend = emailWouldSend.join(',')
      //     }
      //   }
      //   let data = {
      //     company_id: this.$route.params.companyId,
      //     invoice_id: select['docID'],
      //     email: allEmailSend,
      //   }

      //   await axios.post(fc.cloudFunctionUrl + "sendemail", data, {headers})
      //     .then((response) => {
      //       if (response.status === 200) {
      //         this.sendEmailSuccessCount++
      //       }

      //     }, (error) => {
      //       console.log(error)
      //     });
      // })
      const promises = Object.keys(this.emailList).map(async (k) => {
        let data = {
          company_id: this.$route.params.companyId,
          invoice_id: k,
          email: this.emailList[k].join(","),
        };

        await axios
          .post(fc.cloudFunctionUrl + "sendemail", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                this.sendEmailSuccessCount++;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      });

      await Promise.all(promises);
      if (this.sendEmailSuccessCount === this.selectedList.length) {
        this.alert = {
          text: "ส่งอีเมลสำเร็จ " + this.sendEmailSuccessCount + " รายการ",
          type: "success",
          show: true,
        };

        this.sendEmailSuccessCount = 0;

        this.query();
      }
      this.sendEmailLoading = false;
      this.emailDialog = false;
      this.email = "";
      this.emailList = {};
    },
    changeOrderBy: function (order) {
      let orderBySelect = _.cloneDeep(this.orderBySelect);
      if (!(this.orderBySelect["key"] === order)) {
        orderBySelect = { key: order, value: "asc" };
      } else {
        if (_.get(orderBySelect, "value") === "asc") {
          _.set(orderBySelect, "value", "desc");
        } else {
          orderBySelect = {};
        }
      }
      this.$store.dispatch("saleorders/setOrderBySelect", {
        orderBySelect: orderBySelect,
      });
      this.$store.dispatch("saleorders/updatePage", { page: 1 });
      this.query();
    },
    downloadPDF: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "pdf", '@SignedPdfUrl', this.$store.dispatch)
      this.downloadZip("pdf");
    },
    downloadXML: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "xml", '@SignedXmlUrl', this.$store.dispatch)
      this.downloadZip("xml");
    },
    loadingDownloadZip: function (type, onOff) {
      let boolean = onOff === "on";
      if (type === "xml")
        this.$store.dispatch("docsDownloaded/updateDownloadingXml", {
          downloadingXml: boolean,
        });
      else
        this.$store.dispatch("docsDownloaded/updateDownloadingPdf", {
          downloadingPdf: boolean,
        });
    },
    downloadZip: async function (type) {
      this.loadingDownloadZip(type, "on");
      let urlField = "pdfUrl";
      if (type === "xml") {
        urlField = "xmlUrl";
      }
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let docList = [];
      let timeStamp = new Date().getTime();
      // เอาเฉพาะแถวที่มี url
      await this.selectedList.forEach((docSelect) => {
        if (docSelect[urlField]) {
          docList.push({ id: docSelect["docID"], url: docSelect[urlField] });
        }
      });
      await axios
        .post(
          fc.cloudFunctionUrl + "zipFiles",
          {
            data: docList,
            type: type,
            companyID: this.$route.params.companyId,
          },
          { headers, responseType: "arraybuffer" }
        )
        .then(
          (result) => {
            if (result.data.byteLength !== 0) {
              let url = URL.createObjectURL(
                new Blob([result.data], { type: "application/zip" })
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", timeStamp + ".zip");
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            }
            this.loadingDownloadZip(type, "off");
            this.clearSelectList();
          },
          (error) => {
            console.log("front end error: ", error);
            this.loadingDownloadZip(type, "off");
          }
        );
    },
    // onClickDocId: async function (pdfLink) {
    //   if (!pdfLink) {
    //     this.alert = {text: "Signer ยังไม่ได้สร้าง Pdf ให้เอกสารนี้", type: "error", show: true}
    //     return
    //   }

    //   this.downloadPdfLoading = true

    //   if (!this.pdfDialog) {
    //     await axios.get(pdfLink, {
    //       responseType: 'arraybuffer',
    //     })
    //       .then((response) => {
    //         this.downloadPdfLoading = false

    //         let url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));

    //         if (isMobile()) {
    //           let a = document.createElement("a");
    //           document.body.appendChild(a);
    //           a.style = "display: none";
    //           a.href = url;
    //           a.download = "invoice_" + new Date().getTime() + ".pdf";
    //           a.click();
    //           window.URL.revokeObjectURL(url);

    //         } else {
    //           this.pdfSrc = url
    //           this.pdfDialog = true
    //         }

    //       }, (error) => {
    //         console.log(error)
    //       });
    //   }
    // },

    onClickDocId: async function (doc) {
      this.$store.dispatch("setGlobalLoading", true);
      this.downloadPdfLoading = true;

      let pdfLink = doc["@SignedPdfUrl"];
      if (!pdfLink) {
        this.alert = {
          text: "Signer ยังไม่ได้สร้าง Pdf ให้เอกสาร " + doc["objectID"],
          type: "error",
          show: true,
        };
      }
      let unsigedPdfLink = doc["@UnsignedPdfUrl"];

      let link = "";
      if (!pdfLink && !unsigedPdfLink) {
        link = await this.updateUnsignedPdf(doc["objectID"]);
      } else if (pdfLink) {
        link = pdfLink;
      } else if (unsigedPdfLink) {
        link = unsigedPdfLink;
      }

      if (!this.pdfDialog && link) {
        await axios
          .get(link, {
            responseType: "arraybuffer",
          })
          .then(
            (response) => {
              this.downloadPdfLoading = false;

              let url = URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
              );

              if (isMobile()) {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "invoice_" + new Date().getTime() + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
              } else {
                this.pdfSrc = url;
                this.pdfDialog = true;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
      this.$store.dispatch("setGlobalLoading", false);
    },
    updateUnsignedPdf: async function (docID) {
      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let data = {
        companyID: this.$route.params.companyId,
        docID: docID,
      };
      const promise = new Promise((resolve, reject) => {
        axios
          .post(fc.cloudFunctionUrl + "updateUnsignedPdf", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                resolve(response.data);
              }
            },
            (error) => {
              reject(error);
              console.log(error);
            }
          );
      });
      return promise;
    },
    formatDateDur: function (timestamp) {
      // Convert Firebase timestamp to milliseconds
      var milliseconds =
        timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000 + 100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);

      // Use moment.js to format the date
      var parsedDate = moment(date);

      return parsedDate;
    },
    getDateWithFormat: function (timestamp) {
      // Check if timestamp is null or undefined
      if (!timestamp) return '-';

      // Convert Firebase timestamp to milliseconds
      var milliseconds =
        timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000 + 100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);

      // Use moment.js to format the date
      var parsedDate = moment(date);

      // Format the date as per the desired output format
      var formattedDate = parsedDate.format("Do MMM", "th");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");

      // Get the year in Thai Buddhist calendar
      var thaiYear = parseInt(parsedDate.format("YYYY")) + 543; // Add 543 to convert to Thai Buddhist calendar

      // Append the Thai Buddhist year to the formatted date
      formattedDate += " " + thaiYear.toString().substring(2, 4);

      return formattedDate;
    },

    onChangeValueFilterList(value) {
      this.clearValue();
      this.$store.dispatch("saleorders/setValueFilterList", {
        valueFilterList: value,
      });
    },
    onChangeValueDropdownHideColumn(value) {
      this.valueHideList = value;
    },
    onChangeValueSearchOption(value) {
      console.log("onChangeValueSearchOption Triggerrd:: ", value);
      this.defaultSearchOptionValue = value;
      this.$store.dispatch("saleorders/setSearchField", value);
      this.query();
    },
    showColumn(field) {
      return this.valueHideList.includes(field);
    },
    clearValue: function () {
      this.$store.dispatch("saleorders/updatePage", { page: 1 });
    },
    clearSelectList: function () {
      this.$store.dispatch("saleorders/setSelectedList", { selectedList: [] });
    },
    errorsMessage: function (errors) {
      return getErrorMessage(errors);
    },
    onResetPage: function () {
      this.totalCount = 0;
      this.edgeCount = 0;
      this.page = 1;
      this.itemsPerPage =
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"); // hardcode for auto case
      this.first =
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit");
      this.after = null;
      this.last = null;
      this.before = null;
      this.hasNextPage = null;
      this.hasPreviousPage = null;
      this.startCursor = null;
      this.endCursor = null;
    },
    onClickNextPagination: function () {
      this.page += 1;
      this.first = this.itemsPerPage;
      this.after = this.endCursor;
      this.last = null;
      this.before = null;

      this.hasPreviousPage = true;
      this.pageInfo.hasPreviousPage = true;
      this.hasNextPage = null;
      this.pageInfo.hasNextPage = null;

      this.clearAllSelectList();
    },
    onClickPreviousPagination: function () {
      this.page -= 1;
      this.last = this.itemsPerPage;
      this.before = this.startCursor;

      this.first = null;
      this.after = null;

      this.hasPreviousPage = null;
      this.pageInfo.hasPreviousPage = null;
      this.hasNextPage = true;
      this.pageInfo.hasNextPage = true;

      this.clearAllSelectList();
    },
    canNextPage() {
      console.log("can next page", this.loading);
      if (this.hasNextPage !== null) {
        return this.hasNextPage;
      } else if (this.pageInfo) {
        return this.pageInfo.hasNextPage;
      } else {
        return false;
      }
    },
    canPrevPage() {
      if (this.hasPreviousPage !== null) {
        return this.hasPreviousPage;
      } else if (this.pageInfo) {
        return this.pageInfo.hasPreviousPage;
      } else {
        return false;
      }
    },
    getPageDesc() {
      let lastRow = this.page * this.itemsPerPage;
      if (lastRow > this.totalCount) {
        lastRow = this.totalCount;
      }
      let startRow = this.page * this.itemsPerPage - (this.itemsPerPage - 1);
      return `${startRow} - ${lastRow} จาก ${this.totalCount}`;
    },
    onChangePagination(pageLimit) {
      this.loading = true;
      let user = firebase.auth().currentUser;
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store
          .dispatch("user/updatePageLimitSetting", {
            companyId: companyId,
            userId: user.uid,
            pageLimit: pageLimit,
          })
          .then(() => {
            this.page = 1;
            this.itemsPerPage = pageLimit;
            this.first = pageLimit;
            this.after = null;
            this.last = null;
            this.before = null;
            this.hasNextPage = null;
            this.hasPreviousPage = null;
            this.startCursor = null;
            this.endCursor = null;

            this.showPagination = false;
            this.loading = false;
          });
      }
    },
    clearAllSelectList: function () {
      this.selectAll = false;
      this.$store.dispatch("saleorders/setSelectedList", { selectedList: [] });
      this.clearSelectList();
    },
    holdDownloadAndSendEmail: function (status) {
      return companyStatus.holdDownloadAndSendEmail(status);
    },
    autocompleteAddEmail: function (k, value) {
      this.emailInput = "";
      if (value && !this.emailList[k].includes(value)) {
        Vue.observable(this.emailList[k].push(value));
      }
    },
    removeEmail: function (k) {
      this.emailList[k] = [...this.emailValues[k]];
      Vue.observable(this.emailList[k]);
    },
    resetDateSearch: function () {
      this.$store.dispatch("saleorders/setFromDate", "");
      this.$store.dispatch("saleorders/setToDate", "");
      this.$store.dispatch("saleorders/updateKeyword", "");
      this.fromDateVal = null;
      this.toDateVal = null;
      this.clearValue();
    },
    // Import methods
    onOpenImportDialog: function () {
      this.importDialog = true;
    },
    cancelImportDialog: function () {
      this.importDialog = false;
      this.template1 = null;
      this.selectedChannelType = null;
    },
    handleImportFile: function (file) {
      // console.log("Template 1 file selected:", file);
      // TODO: Add file validation logic here
    },
    importDocs: async function () {
      // Validate channel type
      if (!this.selectedChannelType) {
        this.alert = {
          text: "กรุณาเลือกช่องทางการขาย",
          type: "error",
          show: true,
          showOnDialog: true,
        };
        return;
      }

      // Validate files
      if (!this.template1) {
        this.alert = {
          text: "กรุณาเลือกไฟล์ Excel",
          type: "error",
          show: true,
          showOnDialog: true,
        };
        return;
      }

      // Show upload progress
      this.uploadingExcel = true;
      this.uploadProgress = 0;
      this.displayProgress = 0;
      this.uploadProgressMessage = "กำลังเริ่มต้น...";

      try {
        const companyId = this.$route.params.companyId;
        const file = this.template1;

        // Validate file
        const validation = validateExcelFile(file);
        if (!validation.valid) {
          this.alert = {
            text: validation.error,
            type: "error",
            show: true,
            showOnDialog: true,
          };
          this.uploadingExcel = false;
          return;
        }

        // Read Excel file - animate to 15%
        this.uploadProgress = 15;
        this.uploadProgressMessage = "กำลังอ่านไฟล์ Excel...";
        await this.animateProgress(15);

        const rows = await readExcelFile(file);

        if (!rows || rows.length === 0) {
          this.alert = {
            text: "ไม่พบข้อมูลในไฟล์ Excel",
            type: "error",
            show: true,
            showOnDialog: true,
          };
          this.uploadingExcel = false;
          return;
        }

        // Animate to 30%
        this.uploadProgress = 30;
        this.uploadProgressMessage = `พบข้อมูล ${rows.length} แถว กำลังเตรียมส่งข้อมูล...`;
        await this.animateProgress(30);

        // Get auth token
        const token = await fc.auth.currentUser.getIdToken();
        const headers = {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        };

        // Start indeterminate progress while waiting for server
        this.uploadProgressMessage = "กำลังนำเข้าข้อมูล...";
        this.startIndeterminateProgress(30, 90);

        const response = await axios
        .post(
          fc.cloudFunctionUrl + "saleOrdersImporter",
          {
            companyId: companyId,
            channelType: this.selectedChannelType,
            rows: rows,
          },
          { headers }
        );
        // .post(
        //   "http://localhost:5001/sld-etax/us-central1/saleOrdersImporter",
        //   {
        //     companyId: companyId,
        //     channelType: this.selectedChannelType,
        //     rows: rows,
        //   },
        //   { headers }
        // );

        // Stop indeterminate and animate to 100%
        this.stopIndeterminateProgress();

        const result = response.data;

        this.uploadProgress = 100;
        this.uploadProgressMessage = "เสร็จสิ้น";
        await this.animateProgress(100);

        // Wait a moment to show 100% before closing
        await new Promise(resolve => setTimeout(resolve, 600));

        if (result.success) {
          this.alert = {
            text: result.message,
            type: "success",
            show: true,
            showOnDialog: false,
          };
          this.cancelImportDialog();
          // Refresh the list
          this.query();
        } else {
          this.alert = {
            text: result.message,
            type: "error",
            show: true,
            showOnDialog: true,
          };

          // Log errors for debugging
          if (result.errors && result.errors.length > 0) {
            console.error("Import errors:", result.errors);
          }
        }
      } catch (error) {
        console.error("Error importing sale orders:", error);
        const errorMessage = error.response?.data?.message || error.message;
        this.alert = {
          text: "เกิดข้อผิดพลาด: " + errorMessage,
          type: "error",
          show: true,
          showOnDialog: true,
        };
      } finally {
        this.uploadingExcel = false;
        this.uploadProgress = 0;
        this.displayProgress = 0;
        this.uploadProgressMessage = "";
        if (this.progressInterval) {
          clearInterval(this.progressInterval);
          this.progressInterval = null;
        }
      }
    },
    goToUploadHistory: function () {
      console.log("Navigate to upload history");
      // TODO: Implement navigation to upload history page
    },
    // Drag and drop methods
    onDragOver: function (event) {
      this.isDragging = true;
    },
    onDragLeave: function (event) {
      this.isDragging = false;
    },
    onFileDrop: function (event) {
      this.isDragging = false;
      const files = event.dataTransfer.files;

      if (files && files.length > 0) {
        const file = files[0];
        const fileName = file.name.toLowerCase();

        // Validate file extension
        if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {
          this.template1 = file;
          this.handleImportFile(file);
        } else {
          this.alert = {
            text: "กรุณาเลือกไฟล์ Excel เท่านั้น (.xlsx หรือ .xls)",
            type: "error",
            show: true,
            showOnDialog: true,
          };
        }
      }
    },
  },
};
</script>

<style lang="scss">
#table-firebase {
  .filter-up {
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  th {
    img {
      width: 10px;
      height: 8px;
    }
  }

  .border-right {
    border-right: 1px solid #ffffff;
  }

  //add arrow to tooltip
  //.v-tooltip__content::before {
  //  content: '';
  //  position: absolute;
  //  display: block;
  //  width: 0px;
  //  left: 50%;
  //  bottom: 6px;
  //  border: 5px solid transparent;
  //  border-bottom: 0;
  //  border-top: 8px solid #191919;
  //  transform: translate(-50%, calc(100% + 5px));
  //}

  .v-text-field fieldset,
  .v-text-field .v-input__control,
  .v-text-field .v-input__slot {
    border-radius: 10px !important;
    border-color: #c4c4c4;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .search-box {
    width: 250px;
    margin-right: 1rem;
  }

  .remove-checkbox-padding {
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }

  .doc-id {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-text-field__details {
    display: none !important;
  }

  .icon-sort {
    cursor: pointer;
  }

  .v-card__title .v-messages {
    min-height: 11px;
  }

  .order-by-row {
    cursor: pointer;
  }

  .icon-downloaded {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }

  th,
  td {
    white-space: nowrap;
  }

  .check-box-flex {
    display: flex;
    align-items: center;
  }

  tr {
    &.tr-data {
      cursor: pointer;
    }
  }

  .icon-button {
    height: -webkit-fill-available;
  }
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.disabled-btn {
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}

.file-drop-zone {
  position: relative;
  transition: all 0.3s ease;

  &.drag-active {
    .v-input {
      border: 2px dashed #6ec39b !important;
      background-color: rgba(110, 195, 155, 0.05) !important;
    }
  }
}

.smooth-progress {
  .v-progress-linear__determinate {
    transition: width 0.1s ease-out !important;
  }
}
</style>
